module.exports = __webpack_public_path__ + "static/IMG_7888-e906fad3deed2aac2706e132c2f2fdf9.jpg";